
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/advantage",
      function () {
        return require("private-next-pages/advantage/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/advantage"])
      });
    }
  